import { render, staticRenderFns } from "./LagerList.vue?vue&type=template&id=5663010d&"
import script from "./LagerList.vue?vue&type=script&lang=js&"
export * from "./LagerList.vue?vue&type=script&lang=js&"
import style0 from "./LagerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports